import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.some";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep } from 'lodash';
export default {
  props: {
    layer: {
      type: Object,
      default: function _default() {
        return {
          show: false
        };
      }
    }
  },
  data: function data() {
    return {
      checkAll: false,
      checkAlltwo: false,
      positionAuthorities: [],
      mainlandProvinces: [],
      hmtProvinces: [],
      storeId: ''
    };
  },
  computed: {
    isIndeterminateAll: function isIndeterminateAll() {
      var nate = this.mainlandProvinces.some(function (v) {
        return v.selected || v.indeterminate;
      });
      return nate && !this.checkAll;
    },
    isIndeterminateAlltwo: function isIndeterminateAlltwo() {
      var nate = this.hmtProvinces.some(function (v) {
        return v.selected || v.indeterminate;
      });
      return nate && !this.checkAlltwo;
    }
  },
  watch: {
    mainlandProvinces: {
      handler: function handler(val) {
        var all = val.every(function (v) {
          return v.selected;
        });
        this.checkAll = all;
      },
      deep: true
    },
    hmtProvinces: {
      handler: function handler(val) {
        var all = val.every(function (v) {
          return v.selected;
        });
        this.checkAlltwo = all;
      },
      deep: true
    }
  },
  methods: {
    //递归全选/全不选
    forSelected: function forSelected(arr, flog) {
      var _this = this;

      arr.forEach(function (v) {
        _this.$set(v, 'selected', flog);

        if (v.cities && v.cities.length > 0) {
          _this.forSelected(v.cities, flog);
        }
      });
    },
    //中国港澳台权限
    handleCheckAllChangetwo: function handleCheckAllChangetwo() {
      this.forSelected(this.hmtProvinces, this.checkAlltwo);
    },
    //中国大陆权限
    handleCheckAllChange: function handleCheckAllChange() {
      this.forSelected(this.mainlandProvinces, this.checkAll);
    },
    //单个省份全选
    handleCheckChange: function handleCheckChange(e, l) {
      l.indeterminate = false;
      this.forSelected(l.cities, e);
    },
    clickPop: function clickPop(l) {
      var all = l.cities.every(function (v) {
        return v.selected;
      });
      var indeterminate = l.cities.some(function (v) {
        return v.selected;
      });
      l.indeterminate = all ? false : indeterminate;
      l.selected = all;
    },
    dataBind: function dataBind(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(data);
                _context.next = 3;
                return _this2.$api.getDeliveryArea();

              case 3:
                res = _context.sent;
                _this2.storeId = res.storeId;
                _this2.mainlandProvinces = cloneDeep(res.mainlandProvinces);

                _this2.mainlandProvinces.forEach(function (v) {
                  return _this2.init(data, v);
                });

                _this2.hmtProvinces = cloneDeep(res.hmtProvinces);

                _this2.hmtProvinces.forEach(function (v) {
                  return _this2.init(data, v);
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    init: function init(data, v) {
      var _this3 = this;

      if (data.some(function (s) {
        return s.province == v.provinceCode;
      })) {
        v.cities.forEach(function (c) {
          _this3.$set(c, 'selected', data.some(function (s) {
            return s.cities.includes(c.cityCode);
          }));
        });
        this.$set(v, 'selected', v.cities.every(function (s) {
          return s.selected;
        }));
        this.$set(v, 'indeterminate', v.cities.every(function (s) {
          return s.selected;
        }) ? false : v.cities.some(function (s) {
          return s.selected;
        }));
      } else {
        this.$set(v, 'selected', false);
        this.$set(v, 'indeterminate', false);
      }
    },
    confirm: function confirm() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, mainlandProvinces, hmtProvinces;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  wholeCountry: false,
                  mainlandProvinces: _this4.mainlandProvinces,
                  hmtProvinces: _this4.hmtProvinces,
                  storeId: _this4.storeId
                }; //国内

                mainlandProvinces = params.mainlandProvinces.every(function (v) {
                  return v.selected;
                }); //港澳台

                hmtProvinces = params.hmtProvinces.every(function (v) {
                  return v.selected;
                });
                params.wholeCountry = mainlandProvinces && hmtProvinces;

                _this4.$emit('confirm', params);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};